import React, {useState, useEffect} from 'react'
import axios from 'axios'
import { Link, navigate } from "gatsby"
import Col from 'react-bootstrap/Col'
import Tooltip from 'react-bootstrap/Tooltip'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import ModalVideo from 'react-modal-video';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import ShareButton from '../sharebutton'
import Image from "../../components/image"
import OpenApp from "react-open-app";
import Modal from 'react-bootstrap/Modal'
import Loadable from '@loadable/component';

//import your fontawesome icons here
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleRight, faPlay, faTimes } from '@fortawesome/free-solid-svg-icons'
import Styles from './videocards.module.scss'
import 'react-modal-video/scss/modal-video.scss';

const isBrowser = () => typeof window !== "undefined"
const YoutubeReactPlayer = Loadable(() => import('react-player/youtube'));
const VimeoReactPlayer = Loadable(() => import('react-player/vimeo'));
const source = axios.CancelToken.source()

export default function VideoCard(props) {

  const [width, setWidth] = useState(0)
  const [modal_open, setModalToggle] = useState(false)
  const [background_url, setBackgroundUrl] = useState('')

  useEffect(() => {
    if (isBrowser()) {
      setWidth(window.innerWidth);
      const handleResize = () => setWidth(window.innerWidth)
      window.addEventListener("resize", handleResize);
      return () => {
        window.removeEventListener("resize", handleResize);
      };
    }
  }, []);
  useEffect(() => {
    if (props.channel === 'vimeo') {
      axios.get('https://vimeo.com/api/oembed.json?url='+props.url).then(response => response.data).then(data => {
       setBackgroundUrl(data.thumbnail_url)
     });
    }
    return () => source.cancel();
  }, [props.channel, props.url])

  const modalToggle = () => {
    setModalToggle(!modal_open)
  }
  function showWebcast(e) {
    if (e.currentTarget && e.currentTarget.id !== 'share_webcast') {
      if (props.open_video === false) {
        navigate(`${process.env.GATSBY_REACT_APP_API_WEBSITE}/web-recordings/${props.seo_slug}`)
      } else {
        setModalToggle(!modal_open)
      }
    }
  }
  const displayPractitionerName = () => {
    if (props.practitioner_name !== undefined && props.practitioner_name !== '') {
      return (
        <div className="float-left w-100">
          <h3 className="mb-0 w-100 font-12" style={{color: 'rgb(101, 102, 103)'}}>{`By ${props.practitioner_name}`}</h3>
        </div>
      )
    } else {
      if (props.video_page === 'single_webcast_page') {
        return (
          <div className="float-left w-100">
            <h3 className="mb-0 w-100 font-12" style={{color: 'rgb(101, 102, 103)'}}>{`By Leanpitch`}</h3>
          </div>
        )
      } else {
        return null
      }
    }
  }
  const backgroundUrl = () => {
    let image_url = ''
    if (props.avatar === undefined || props.avatar === '') {
      if (props.channel === 'vimeo') {
        image_url = background_url
      } else {
        image_url = `https://img.youtube.com/vi/${props.video_id}/mqdefault.jpg`
      }
    }else {
      image_url = props.avatar
    }
    return image_url
  }
  const displayPlayer = () => {
    if (props.channel === 'vimeo') {
      return (
        <VimeoReactPlayer className={`${Styles.react_player}`} url={`${props.url}`} width="100%" height={"100%"} controls={true} config={{vimeo: {playerOptions: { height: '100%' }}}}/>
      );
    } else {
      return (
        <YoutubeReactPlayer className={`${Styles.react_player}`} url={`${props.url}`} width="100%" height={"100%"} controls={true} config={{youtube: {playerVars: { rel: 0 }}}}/>
      );
    }
  }
  const displayPlayerModal = () => {
    return (
      <Modal show={modal_open} onHide={modalToggle} size={width > 980 ? 'xl' : 'lg'} centered dialogClassName={width <= 980 ? `${Styles.small_video_modal} m-0` : Styles.video_modal}>
        <Modal.Body className={`p-2 ${width <= 980 ? '' : 'position-relative'}`} style={{background: 'rgb(0, 0, 0)', borderRadius: width > 980 ?  '10px' : 0}}>
          {width <= 980 ? null : <FontAwesomeIcon icon={faTimes} className="text-white pointer position-absolute" size="lg" style={{right: '-1.5rem', top: '-1.5rem'}} onClick={modalToggle} />}
          <div className={`${Styles.player_wrapper}`}>
            {displayPlayer()}
          </div>
        </Modal.Body>
      </Modal>
    );
  }

  if (width !== 0) {
    if (width <= 980) {
      if (props.video_page === 'course_testimonial_training') {
        return (
          <div className={`float-left px-0 mr-2`} style={{position: 'relative', maxWidth: '140px', minWidth: '140px', minHeight: '75px', maxHeight: '75px'}}>
            <Col md="12" sm="12" xs="12" className={`float-left px-0`} id={props.channel === 'vimeo' ? `vimeo-${props.video_id}` : `youtube-${props.video_id}`} style={{borderRadius: '10px', height: '100%'}}>
              <div className={`${Styles.testimonial_video_card_overlay}`} />
              <picture>
                <LazyLoadImage src={backgroundUrl()} alt={`${props.title.toLowerCase().split(' ').join('-')}`} style={{width: "100%", borderRadius: '10px', minHeight: '75px', maxHeight: '75px'}}/>
              </picture>
              <FontAwesomeIcon className="pointer text-white" icon={faPlay} size="lg" style={{position: 'absolute', right: '45%', top: '40%', zIndex: 2}} onClick={modalToggle}/>
            </Col>
            {displayPlayerModal()}
            {/* <ModalVideo channel={props.channel} isOpen={modal_open} videoId={props.video_id} onClose={() => setModalToggle(false)} /> */}
          </div>
        )
      } else if (props.video_page === 'sales_page_carousel_videos') {
        return (
          <Col xs="12" sm="6" md="6" className="float-left d-flex align-items-center p-3 mb-2" onClick={modalToggle}>
            <Col xs="4" sm="5" md="4" className="float-left px-0">
              <picture>
                <LazyLoadImage src={backgroundUrl()} alt={`${props.title.toLowerCase().split(' ').join('-')}`} style={{width: "100%", borderRadius: '5px', minHeight: '75px', maxHeight: '75px'}}/>
              </picture>
            </Col>
            <Col xs="8" sm="7" md="8" className="float-left pl-2 pr-0 d-flex align-items-center">
              <div className="float-left w-100 pr-1">
                <h3 className="mb-1 font-weight-bold w-100 font-14 ellipsis_3_effect" style={{color: 'rgb(59, 59, 59)'}}>{props.title}</h3>
                {displayPractitionerName()}
              </div>
              <FontAwesomeIcon icon={faAngleRight} className="mb-1 font-weight-bold font-14" style={{color: 'rgb(59, 59, 59)'}}/>
            </Col>
            {displayPlayerModal()}
            {/* <ModalVideo channel={props.channel} isOpen={modal_open} videoId={props.video_id} onClose={() => setModalToggle(false)} /> */}
          </Col>
        )
      } else if (props.video_page === 'sales_page_videos') {
        return (
          <Col xs="12" sm="6" md="6" className={`float-left align-items-center p-3 mb-2 ${props.hidden === '' ? 'd-flex' : props.hidden}`} style={{boxShadow: 'rgb(216, 214, 214) 0px 15px 9px -9px'}} onClick={modalToggle}>
            <Col xs="4" sm="5" md="43" className="float-left px-0">
              <picture>
                <LazyLoadImage src={backgroundUrl()} alt={`${props.title.toLowerCase().split(' ').join('-')}`} style={{width: "100%", borderRadius: '5px', minHeight: '75px', maxHeight: '75px'}}/>
              </picture>
            </Col>
            <Col xs="8" sm="7" md="8" className="float-left pl-2 pr-0 d-flex align-items-center">
              <div className="float-left w-100 pr-1">
                <h3 className="mb-1 font-weight-bold w-100 font-14 ellipsis_3_effect" style={{color: 'rgb(59, 59, 59)'}}>{props.title}</h3>
                {displayPractitionerName()}
              </div>
              <FontAwesomeIcon icon={faAngleRight} className="mb-1 font-weight-bold font-14" style={{color: 'rgb(59, 59, 59)'}}/>
            </Col>
            {displayPlayerModal()}
            {/* <ModalVideo channel={props.channel} isOpen={modal_open} videoId={props.video_id} onClose={() => setModalToggle(false)} /> */}
          </Col>
        )
      } else if (props.video_page === 'single_video_page') {
        return (
          <Link to={`/videos/${props.seo_slug}`}>
            <Col xs="12" sm="6" md="6" className="float-left d-flex align-items-center p-3 mb-2" style={{boxShadow: 'rgb(216, 214, 214) 0px 15px 9px -9px'}}>
              <Col xs="4" sm="5" md="4" className="float-left px-0">
                <picture>
                  <LazyLoadImage src={props.seo_image} alt={`${props.title.toLowerCase().split(' ').join('-')}`} style={{width: "100%", borderRadius: '5px', minHeight: '75px', maxHeight: '75px'}}/>
                </picture>
              </Col>
              <Col xs="8" sm="7" md="8" className="float-left pl-2 pr-0 d-flex align-items-center">
                <div className="float-left w-100 pr-1">
                  <h3 className="mb-1 font-weight-bold w-100 font-14 ellipsis_3_effect" style={{color: 'rgb(59, 59, 59)'}}>{props.title}</h3>
                  {displayPractitionerName()}
                </div>
                <FontAwesomeIcon icon={faAngleRight} className="mb-1 font-weight-bold font-14" style={{color: 'rgb(59, 59, 59)'}}/>
              </Col>
            </Col>
          </Link>
        )
      } else if (props.video_page === 'single_webcast_page') {
        return (
          <Link to={`/web-recordings/${props.seo_slug}`}>
            <Col xs="12" sm="6" md="6" className="float-left d-flex align-items-center p-3 mb-2" style={{boxShadow: 'rgb(216, 214, 214) 0px 15px 9px -9px'}}>
              <Col xs="4" sm="5" md="4" className="float-left px-0">
                <picture>
                  <LazyLoadImage src={props.seo_image} alt={`${props.title.toLowerCase().split(' ').join('-')}`} style={{width: "100%", borderRadius: '5px', minHeight: '75px', maxHeight: '75px'}}/>
                </picture>
              </Col>
              <Col xs="8" sm="7" md="8" className="float-left pl-2 pr-0 d-flex align-items-center">
                <div className="float-left w-100 pr-1">
                  <h3 className="mb-1 font-weight-bold w-100 font-14 ellipsis_3_effect" style={{color: 'rgb(59, 59, 59)'}}>{props.title}</h3>
                  {displayPractitionerName()}
                </div>
                <FontAwesomeIcon icon={faAngleRight} className="mb-1 font-weight-bold font-14" style={{color: 'rgb(59, 59, 59)'}}/>
              </Col>
            </Col>
          </Link>
        )
      } else if (props.video_page === 'search_result_videos') {
        return (
          <Col xs="12" sm="6" md="6" key={props.index} style={{padding:'10px 7px'}}>
            <Col xs="12" sm="12" md="12" className="float-left px-0 d-flex align-items-center py-2 bg-white" style={{borderRadius: '5px', border: '1px solid rgb(211, 234, 244)', minHeight: '100px', maxHeight: '100px'}} onClick={modalToggle}>
              {backgroundUrl() !== '' ?
                <div className="float-left px-2" style={{minWidth: '100px', maxWidth: '100px'}}>
                  <picture>
                    <LazyLoadImage src={backgroundUrl()} alt={`${props.title.toLowerCase().split(' ').join('-')}`} style={{width: "100%", borderRadius: '5px', minHeight: '75px', maxHeight: '75px'}}/>
                  </picture>
                </div> : null}
                <div className="float-left w-100 pr-2">
                  <h3 className="mb-1 font-weight-bold w-100 font-14 ellipsis_2_effect" style={{color: 'rgb(59, 59, 59)'}}>{props.title}</h3>
                  {displayPractitionerName()}
                </div>
            </Col>
            {displayPlayerModal()}
            {/* <ModalVideo channel={props.channel} isOpen={modal_open} videoId={props.video_id} onClose={() => setModalToggle(false)} /> */}
          </Col>
        )
      } else if (props.video_page === 'video_testimonial_page') {
        return (
          <Col xs="12" sm="6" md="6" className={`float-left align-items-center p-3 mb-2 ${props.hidden === '' ? 'd-flex' : props.hidden}`} style={{boxShadow: 'rgb(216, 214, 214) 0px 15px 9px -9px'}} onClick={modalToggle}>
            <Col xs="4" sm="5" md="4" className="float-left px-0">
              <picture>
                <LazyLoadImage src={backgroundUrl()} alt={`${props.title.toLowerCase().split(' ').join('-')}`} style={{width: "100%", borderRadius: '5px', minHeight: '75px', maxHeight: '75px'}}/>
              </picture>
            </Col>
            <Col xs="8" sm="7" md="8" className="float-left pl-2 pr-0 d-flex align-items-center">
              <div className="float-left w-100 pr-1">
                <h3 className="mb-1 font-weight-bold w-100 font-14 ellipsis_3_effect" style={{color: 'rgb(59, 59, 59)'}}>{props.title}</h3>
              </div>
              <FontAwesomeIcon icon={faAngleRight} className="mb-1 font-weight-bold font-14" style={{color: 'rgb(59, 59, 59)'}}/>
            </Col>
            {displayPlayerModal()}
            {/* <ModalVideo channel={props.channel} isOpen={modal_open} videoId={props.video_id} onClose={() => setModalToggle(false)} /> */}
          </Col>
        )
      } else if (props.video_page === 'homepage_testimonial') {
        return (
          <div key={props.index} className="float-left" style={{padding:'10px 7px', minWidth: '275px', maxWidth: '275px'}}>
            <Col xs="12" sm="12" md="12" className="float-left px-0 d-flex align-items-center py-2 bg-white" style={{borderRadius: '5px', border: '1px solid rgb(211, 234, 244)'}} onClick={modalToggle}>
              {backgroundUrl() !== '' ?
                <div className="float-left px-2" style={{minWidth: '100px', maxWidth: '100px'}}>
                  <picture>
                    <LazyLoadImage src={backgroundUrl()} alt={`${props.title.toLowerCase().split(' ').join('-')}`} style={{width: "100%", borderRadius: '5px', minHeight: '75px', maxHeight: '75px'}}/>
                  </picture>
                </div> : null}
              <div className="float-left pr-2 d-flex align-items-center w-100">
                <div className="float-left w-100">
                  <h3 className="mb-1 font-weight-bold w-100 font-14 ellipsis_3_effect" style={{color: 'rgb(59, 59, 59)'}}>{props.title}</h3>
                </div>
                <FontAwesomeIcon icon={faAngleRight} className="mb-1 font-weight-bold font-14" style={{color: 'rgb(49, 159, 203)'}}/>
              </div>
            </Col>
            {displayPlayerModal()}
            {/* <ModalVideo channel={props.channel} isOpen={modal_open} videoId={props.video_id} onClose={() => setModalToggle(false)} /> */}
          </div>
        )
      } else if (props.video_page === 'trainer_video_page') {
        return (
          <Col xs="12" sm="6" md="6" className={`float-left align-items-center p-3 mb-2 d-flex`} style={{boxShadow: 'rgba(204, 204, 204, 0.66) 0px 3px 9px 0.2px', borderRadius: '5px'}} onClick={modalToggle}>
            <Col xs="4" sm="3" md="3" className="float-left px-0" style={{minWidth: '125px', maxWidth: '125px'}}>
              <picture>
                <LazyLoadImage src={backgroundUrl()} alt={`${props.title.toLowerCase().split(' ').join('-')}`} style={{width: "100%", borderRadius: '3px', minHeight: '75px', maxHeight: '75px'}}/>
              </picture>
            </Col>
            <Col xs="8" sm="9" md="9" className="float-left pl-2 pr-0">
              <h3 className="mb-1 font-weight-bold w-100 font-14 ellipsis_3_effect" style={{color: 'rgb(59, 59, 59)'}}>{props.title}</h3>
            </Col>
            {displayPlayerModal()}
            {/* <ModalVideo channel={props.channel} isOpen={modal_open} videoId={props.video_id} onClose={() => setModalToggle(false)} /> */}
          </Col>
        )
      } else if (props.video_page === 'free_videos') {
        return (
          <Col xs="12" sm="6" md="6" className={`float-left p-3 mb-2 align-items-center ${props.hidden === '' ? 'd-flex' : props.hidden}`} style={{boxShadow: 'rgb(216, 214, 214) 0px 15px 9px -9px'}} onClick={modalToggle}>
            <Col xs="4" sm="5" md="4" className="float-left px-0">
              <picture>
                <LazyLoadImage src={backgroundUrl()} alt={`${props.title.toLowerCase().split(' ').join('-')}`} style={{width: "100%", borderRadius: '5px', minHeight: '75px', maxHeight: '75px'}}/>
              </picture>
            </Col>
            <Col xs="8" sm="7" md="8" className="float-left pl-2 pr-0 d-flex align-items-center">
              <div className="float-left w-100 pr-1">
                <h3 className="mb-1 font-weight-bold w-100 font-14 ellipsis_3_effect" style={{color: 'rgb(59, 59, 59)'}}>{props.title}</h3>
                {displayPractitionerName()}
              </div>
              <FontAwesomeIcon icon={faAngleRight} className="mb-1 font-weight-bold font-14" style={{color: 'rgb(59, 59, 59)'}}/>
            </Col>
            {displayPlayerModal()}
            {/* <ModalVideo channel={props.channel} isOpen={modal_open} videoId={props.video_id} onClose={() => setModalToggle(false)} /> */}
          </Col>
        )
      } else if (props.video_page === 'webcast') {
        return (
          <Col xs="12" sm="6" md="6" className="float-left p-3 mb-2 d-flex  align-items-center" style={{boxShadow: 'rgb(216, 214, 214) 0px 15px 9px -9px'}} onClick={modalToggle}>
            <Col xs="4" sm="5" md="4" className="float-left px-0">
              <picture>
                <LazyLoadImage src={backgroundUrl()} alt={`${props.title.toLowerCase().split(' ').join('-')}`} style={{width: "100%", borderRadius: '5px', minHeight: '75px', maxHeight: '75px'}}/>
              </picture>
            </Col>
            <Col xs="8" sm="7" md="8" className="float-left pl-2 pr-0 d-flex align-items-center">
              <div className="float-left w-100 pr-1">
                <h3 className="mb-1 font-weight-bold w-100 font-14 ellipsis_3_effect" style={{color: 'rgb(59, 59, 59)'}}>{props.title}</h3>
                {displayPractitionerName()}
              </div>
              <FontAwesomeIcon icon={faAngleRight} className="mb-1 font-weight-bold font-14" style={{color: 'rgb(59, 59, 59)'}}/>
            </Col>
            {displayPlayerModal()}
            {/* <ModalVideo channel={props.channel} isOpen={modal_open} videoId={props.video_id} onClose={() => setModalToggle(false)} /> */}
          </Col>
        )
      } else if (props.video_page === 'speak_series_page') {
        return (
          <Col xs="12" sm="6" md="6" className={`float-left p-3 mb-2 align-items-center d-flex`} style={{boxShadow: 'rgb(216, 214, 214) 0px 15px 9px -9px'}} onClick={modalToggle}>
            <Col xs="4" sm="5" md="4" className="float-left px-0">
              <picture>
                <LazyLoadImage src={backgroundUrl()} alt={`${props.title.toLowerCase().split(' ').join('-')}`} style={{width: "100%", borderRadius: '5px', minHeight: '75px', maxHeight: '75px'}}/>
              </picture>
            </Col>
            <Col xs="8" sm="7" md="8" className="float-left pl-2 pr-0 d-flex align-items-center">
              <div className="float-left w-100 pr-1">
                <h3 className="mb-1 font-weight-bold w-100 font-14 ellipsis_3_effect" style={{color: 'rgb(59, 59, 59)'}}>{props.title}</h3>
              </div>
              <FontAwesomeIcon icon={faAngleRight} className="mb-1 font-weight-bold font-14" style={{color: 'rgb(59, 59, 59)'}}/>
            </Col>
            {displayPlayerModal()}
            {/* <ModalVideo channel={props.channel} isOpen={modal_open} videoId={props.video_id} onClose={() => setModalToggle(false)} /> */}
          </Col>
        )
      } else {
        let url = ''
        if (props.channel === 'youtube') {
          url = props.video_id;
        }
        if(props.channel === 'vimeo'){
          url = props.vimeo_url;
        }
        return (
          <Col xs="12" sm="6" md="6" className="float-left p-3 mb-2" style={{boxShadow: 'rgb(216, 214, 214) 0px 15px 9px -9px'}}>
            <OpenApp href="https://leanpitch.com" android={`https://eskola.io/VideoPlayingYtube?video_url=${url}&&course_name=${props.title}&&prev_page=VideoPlaying`} ios={`leanpitch://leanpitch.com/VideoPlayingYtube?video_url=${url}&&course_name=${props.title}&&prev_page=VideoPlaying`} className="d-flex align-items-center">
              <Col xs="4" sm="5" md="4" className="float-left px-0">
                <picture>
                  <LazyLoadImage src={backgroundUrl()} alt={`${props.title.toLowerCase().split(' ').join('-')}`} style={{width: "100%", borderRadius: '5px', minHeight: '75px', maxHeight: '75px'}}/>
                </picture>
              </Col>
              <Col xs="8" sm="7" md="8" className="float-left pl-2 pr-0 d-flex align-items-center">
                <div className="float-left w-100 pr-1">
                  <h3 className="mb-1 font-weight-bold w-100 font-14 ellipsis_3_effect" style={{color: 'rgb(59, 59, 59)'}}>{props.title}</h3>
                  {displayPractitionerName()}
                </div>
                <FontAwesomeIcon icon={faAngleRight} className="mb-1 font-weight-bold font-14" style={{color: 'rgb(59, 59, 59)'}}/>
              </Col>
            </OpenApp>
          </Col>
        )
      }
    } else {
      if (props.video_page === 'training detail') {
        //   if (props.channel === 'vimeo') {
        //     return (
        //       <Col xs="12" sm="12" md="12" lg="12" className={`${Styles.flex_centered } ${Styles.video_resource_item } ${Styles.view_more_section } p-2 pointer`} onClick={modalToggle} >
        //         <Col xs="4" sm="4" md="4" lg="4" className="px-0 text-center">
        //           <picture>
        //             <LazyLoadImage src={background_url} alt={props.title} style={{width: "100%", height: '100%', borderRadius: '7px'}}/>
        //           </picture>
        //         </Col>
        //         <Col xs="8" sm="8" md="8" lg="8" className="">
        //           <h6 className={`${Styles.flex_centered}`}>{props.title}</h6>
        //         </Col>
        //         <ModalVideo channel={props.channel} isOpen={modal_open} videoId={props.video_id} onClose={() => setModalToggle(false)} />
        //       </Col>
        //     )
        //   } else {
          return (
            <Col xs="12" sm="12" md="12" lg="12" className={`${Styles.flex_centered } ${Styles.video_resource_item } ${Styles.view_more_section } p-2 pointer`} onClick={modalToggle} >
              <Col xs="4" sm="4" md="4" lg="4" className="px-0 text-center" id={props.channel === 'vimeo' ? `vimeo-${props.video_id}` : `youtube-${props.video_id}`}>
                <picture>
                  <LazyLoadImage src={props.channel === 'vimeo' ? background_url : `https://img.youtube.com/vi/${props.video_id}/mqdefault.jpg`} alt={props.title} style={{width: "100%", height: '100%', borderRadius: '7px'}}/>
                </picture>
              </Col>
              <Col xs="8" sm="8" md="8" lg="8" className="">
                <h6 className={`${Styles.flex_centered}`}>{props.title}</h6>
              </Col>
              {displayPlayerModal()}
              {/* <ModalVideo channel={props.channel} isOpen={modal_open} videoId={props.video_id} onClose={() => setModalToggle(false)} /> */}
            </Col>
          )
        // }
      }else if (props.video_page === 'dashboard') {
        // if (props.channel === 'vimeo') {
        //   return (
        //     <Col xs="12" sm="12" md="12" lg="12" className={`${Styles.flex_centered } ${Styles.video_resource_item } ${Styles.view_more_section } ${Styles.dashboard_video_hover } p-2 pointer text-white`} onClick={modalToggle} >
        //       <Col xs="3" sm="3" md="3" lg="3" className="px-0 text-center" style={{minWidth:'115px'}}>
        //         <picture>
        //           <img src={background_url} alt={props.title} style={{width: "100%", height: 'auto', borderRadius: '7px', minWidth:'115px', minHeight:'70px'}}/>
        //         </picture>
        //       </Col>
        //       <Col xs="9" sm="9" md="9" lg="9" className="">
        //         <h6 className={`${Styles.flex_centered}`}>{props.title}</h6>
        //       </Col>
        //       <ModalVideo channel={props.channel} isOpen={modal_open} videoId={props.video_id} onClose={() => setModalToggle(false)} />
        //     </Col>
        //   )
        // } else {
          return (
            <Col xs="12" sm="12" md="12" lg="12" className={`${Styles.flex_centered } ${Styles.video_resource_item } ${Styles.view_more_section } ${Styles.dashboard_video_hover } p-2 pointer`} onClick={modalToggle} >
              <Col xs="3" sm="3" md="3" lg="3" className="px-0 text-center" id={props.channel === 'vimeo' ? `vimeo-${props.video_id}` : `youtube-${props.video_id}`} style={{minWidth:'115px'}}>
                <picture>
                  <img src={props.channel === 'vimeo' ? background_url : `https://img.youtube.com/vi/${props.video_id}/mqdefault.jpg`} alt={props.title} style={{width: "100%", height: 'auto', borderRadius: '7px', minWidth:'115px', minHeight:'70px'}}/>
                </picture>
              </Col>
              <Col xs="9" sm="9" md="9" lg="9" className="text-white">
                <h6 className={`${Styles.flex_centered}`}>{props.title}</h6>
              </Col>
              {displayPlayerModal()}
              {/* <ModalVideo channel={props.channel} isOpen={modal_open} videoId={props.video_id} onClose={() => setModalToggle(false)} /> */}
            </Col>
          )
        // }
      }else if (props.video_page === 'webcast') {
        let image_url = ''
        if (props.avatar === undefined || props.avatar === '') {
          if (props.channel === 'vimeo') {
            image_url = background_url
          } else if (props.channel === 'youtube') {
            image_url = `https://img.youtube.com/vi/${props.video_id}/mqdefault.jpg`
          } else {
            image_url = `https://img.youtube.com/vi/${props.video_id}/mqdefault.jpg`
          }
        }else {
          image_url = props.avatar
        }
        let url = ''
        if (props.shareType) {
          url = `${process.env.GATSBY_REACT_APP_API_WEBSITE}/web-recordings/${props.seo_slug}`
        }
        return (
          <div className={`float-left mt-0 mb-3 ${props.type === "event" ? `mx-auto` : `mr-4`} pointer`} style={{ width: props.type === "event" ? `210px` : `250px` }} onClick={(e) => showWebcast(e)} >
            <div className={`float-left`} style={{ boxShadow: 'rgb(216, 214, 214) 0px 0px 9px 2px', borderRadius: '15px' }}>
              <div style={{ position: `relative`, borderBottom: `1px solid #ebebeb` }}>
                <LazyLoadImage src={image_url} alt={props.title} effect="blur" height={props.type === "event" ? '117px' : '141px'} width={props.type === "event" ? `210px` : `250px`}
                  style={{ margin: '0px', objectFit: `cover`, borderTopLeftRadius: `15px`, borderTopRightRadius: `15px` }}
                />
                { props.license_type ?
                  <div className={`${props.license_type !== 'Basic' ? '' : 'd-none'}`} style={{ position: `absolute`, top: `0`, left: `0`}}>
                    <Image src={props.license_type.toLowerCase()+'_pricing.png'} imgStyle={{ objectFit: `cover` }} style={{ width: `80px`, height: `80px`, zIndex: 1 }} type={`fluid`} />
                  </div> : ''
                }
              </div>
              <Col lg="12" md="12" sm="12" xs="12" className={`float-left pt-2 pb-3`} style={{position: `relative`}}>
                <div className={`mb-2 d-flex tooltip-div-event`} style={{ height: `38px` }}>
                {props.title && props.title.length > props.type === "event" ? 39 : 46 ?
                  <OverlayTrigger
                    placement={'top'}
                    overlay={
                      <Tooltip className="event-tooltip" id={`event-${props.id}`} >
                        {props.title ? props.title : ""}
                      </Tooltip>
                    }
                  >
                    <h6 className={`ellipsis_2_effect bold m-0 align-self-center`} style={{fontSize: `16px`}}>{props.title ? props.title : ""}</h6>
                  </OverlayTrigger>
                  :
                  <h6 className={`ellipsis_2_effect bold m-0 align-self-center`} style={{fontSize: `16px`}}>{props.title ? props.title : ""}</h6>
                }
                </div>
                <p className={`ellipsis_1_effect m-0 ${props.author === "event" ? 'd-none' : ''}`} style={{fontSize: props.type === "event" ? `13px` : `15px`}}>By {props.author !== '' ? props.author.length > 24 ? props.author.slice(0, 24) + '...' : props.author : "Leanpitch"}</p>
                {props.seo_slug ?
                  <ShareButton page_type="webcast" title={props.title} url={url} summary={props.seo_description}/>
                  :
                  <React.Fragment></React.Fragment>
                }
              </Col>
            </div>
            {displayPlayerModal()}
            {/* <ModalVideo channel={props.channel} isOpen={modal_open} videoId={props.video_id} onClose={() => setModalToggle(false)} /> */}
          </div>
        )
      }else if (props.video_page === 'video_testimonial_page') {
        // if (props.channel === 'vimeo') {
        //   return (
        //     <Col sm="12" md="12" lg="12" className={`float-left mb-5 ${props.hidden}`} style={{position: 'relative'}}>
        //       <Col md="12" sm="12" lg="12" className={`float-left px-0 ${Styles.video_card_transform}`}>
        //         <Col md="11" sm="11" lg="11" className={`float-left px-0`} id={`vimeo-`+props.video_id} style={{minHeight: '220px', maxHeight: '220px', boxShadow: 'rgb(216, 214, 214) 0px 0px 9px 2px', borderRadius: '15px'}}>
        //           <div className={`${Styles.testimonial_video_card_overlay}`} id={props.channel === 'vimeo' ? `vimeo-${props.video_id}` : `youtube-${props.video_id}`} />
        //           <picture>
        //             <LazyLoadImage src={background_url} alt={`${props.title.toLowerCase().split(' ').join('-')}`} style={{width: "100%", minHeight: '220px', maxHeight: '220px', borderRadius: '15px'}}/>
        //           </picture>
        //           <FontAwesomeIcon className="pointer text-white" icon={faPlay} size="lg" style={{position: 'absolute', right: '45%', top: '40%', zIndex: 2}} onClick={modalToggle}/>
        //         </Col>
        //         <Col sm="12" md="12" lg="12" className={`float-left mt-3`}>
        //           <h5 style={{textAlign: 'left', fontSize: '1.1vw'}}> {props.title} </h5>
        //         </Col>
        //       </Col>
        //       <ModalVideo channel={props.channel} isOpen={modal_open} videoId={props.video_id} onClose={() => setModalToggle(false)} />
        //     </Col>
        //   )
        // } else {
          return (
            <Col sm="12" md="12" lg="12" className={`float-left mb-5 ${props.hidden}`} style={{position: 'relative'}}>
              <Col md="12" sm="12" lg="12" className={`float-left px-0 ${Styles.video_card_transform}`}>
                <Col md="11" sm="11" lg="11" className={`float-left px-0`} style={{minHeight: '220px', maxHeight: '220px', boxShadow: 'rgb(216, 214, 214) 0px 0px 9px 2px', borderRadius: '15px'}}>
                  <div className={`${Styles.testimonial_video_card_overlay}`} id={props.channel === 'vimeo' ? `vimeo-${props.video_id}` : `youtube-${props.video_id}`} />
                  <picture>
                    <LazyLoadImage src={props.channel === 'vimeo' ? background_url : `https://img.youtube.com/vi/${props.video_id}/mqdefault.jpg`} alt={`${props.title.toLowerCase().split(' ').join('-')}`} style={{width: "100%", minHeight: '220px', maxHeight: '220px', borderRadius: '15px'}}/>
                  </picture>
                  <FontAwesomeIcon className="pointer text-white" icon={faPlay} size="3x" style={{position: 'absolute', right: '45%', top: '40%', zIndex: 2}} onClick={modalToggle}/>
                </Col>
                <Col sm="12" md="12" lg="12" className={`float-left mt-3`}>
                  <h5 style={{textAlign: 'left', fontSize: '1.1vw'}}> {props.title} </h5>
                </Col>
              </Col>
              {displayPlayerModal()}
              {/* <ModalVideo channel={props.channel} isOpen={modal_open} videoId={props.video_id} onClose={() => setModalToggle(false)} /> */}
            </Col>
          )
        // }
      }else if (props.video_page === 'single_video_page') {
        return (
          <Link to={`/videos/${props.seo_slug}`}>
            <Col sm="12" md="12" lg="12" className={`float-left mb-4`} style={{position: 'relative'}}>
              <Col md="12" sm="12" lg="12" className={`float-left px-0 ${Styles.video_card_transform}`} style={{minHeight: '200px', maxHeight: '200px'}}>
                <div className={`${Styles.video_card_overlay}`} />
                <Col md="12" sm="12" lg="12" className={`float-left px-0`} style={{boxShadow: 'rgb(216, 214, 214) 0px 0px 9px 2px', borderRadius: '15px'}}>
                  <picture>
                    <LazyLoadImage src={props.seo_image} alt={`${props.title.toLowerCase().split(' ').join('-')}`} style={{width: "100%", minHeight: '200px', maxHeight: '200px', borderRadius: '15px', color: 'rgb(0, 0, 0)'}}/>
                  </picture>
                </Col>
                <ShareButton page_type="video" title={props.title} url={`${process.env.GATSBY_REACT_APP_API_WEBSITE}/videos/${props.seo_slug}`} summary={props.summary} style={{position: 'absolute', right: '0', color: 'rgb(255, 255, 255)', zIndex: 5, top: '2px'}}/>
                <Col sm="12" md="12" lg="12" className={`float-left ${props.title === undefined ? 'hidden' : ''}`} style={{zIndex: 2, position: 'absolute', bottom: '0', left: '0'}}>
                  <h6 className="text-white ellipsis_2_effect" style={{textAlign: 'left', fontSize: '1.2vw'}}> {props.title} </h6>
                  <h6 className={`text-white ${props.practitioner_name === undefined || props.practitioner_name === '' ? 'd-none' : ''}`} style={{textAlign: 'left', fontSize: '0.95vw'}}> {`By ${props.practitioner_name}`} </h6>
                </Col>
              </Col>
            </Col>
          </Link>
        )
      }else if (props.video_page === 'single_webcast_page') {
        return (
          <Link to={`/web-recordings/${props.seo_slug}`} className="text-black">
            <div className={`float-left mt-0 mb-3 ${props.type === "event" ? `mx-auto` : `mr-4`} pointer`} style={{ width: props.type === "event" ? `210px` : `250px` }}>
              <div className={`float-left`} style={{ boxShadow: 'rgb(216, 214, 214) 0px 0px 9px 2px', borderRadius: '15px' }}>
                <div style={{ position: `relative`, borderBottom: `1px solid #ebebeb` }}>
                  <LazyLoadImage src={props.seo_image} alt={props.title.toLowerCase().split(' ').join('-')} effect="blur" height={props.type === "event" ? '117px' : '141px'} width={props.type === "event" ? `210px` : `250px`}
                    style={{ margin: '0px', objectFit: `cover`, borderTopLeftRadius: `15px`, borderTopRightRadius: `15px`, color: 'rgb(0, 0, 0)' }}
                  />
                  { props.license_type ?
                    <div className={`${props.license_type !== 'Basic' ? '' : 'd-none'}`} style={{ position: `absolute`, top: `0`, left: `0`}}>
                      <Image src={props.license_type.toLowerCase()+'_pricing.png'} imgStyle={{ objectFit: `cover` }} style={{ width: `80px`, height: `80px`, zIndex: 1 }} type={`fluid`} />
                    </div> : ''
                  }
                </div>
                <Col lg="12" md="12" sm="12" xs="12" className={`float-left pt-2 pb-3`} style={{position: `relative`}}>
                  <div className={`mb-2 d-flex tooltip-div-event`} style={{ height: `38px` }}>
                  {props.title && props.title.length > props.type === "event" ? 39 : 46 ?
                    <OverlayTrigger
                      placement={'top'}
                      overlay={
                        <Tooltip className="event-tooltip" id={`event-${props.id}`} >
                          {props.title ? props.title : ""}
                        </Tooltip>
                      }
                    >
                      <h6 className={`ellipsis_2_effect bold m-0 align-self-center`} style={{fontSize: `16px`}}>{props.title ? props.title : ""}</h6>
                    </OverlayTrigger>
                    :
                    <h6 className={`ellipsis_2_effect bold m-0 align-self-center`} style={{fontSize: `16px`}}>{props.title ? props.title : ""}</h6>
                  }
                  </div>
                  <p className={`ellipsis_1_effect m-0 ${props.author === "event" ? 'd-none' : ''}`} style={{fontSize: props.type === "event" ? `13px` : `15px`}}>By {props.author !== '' ? props.author.length > 24 ? props.author.slice(0, 24) + '...' : props.author : "Leanpitch"}</p>
                  {props.seo_slug ?
                    <ShareButton page_type="webcast" title={props.title} url={`${process.env.GATSBY_REACT_APP_API_WEBSITE}/web-recordings/${props.seo_slug}`} summary={props.summary}/>
                    :
                    <React.Fragment></React.Fragment>
                  }
                </Col>
              </div>
            </div>
          </Link>
        )
      }else if (props.video_page === 'search_result_videos') {
        // if (props.channel === 'vimeo') {
        //   return (
        //     <div className={`float-left mb-4 px-2`} style={{position: 'relative', maxWidth: '315px', minWidth: '315px'}} onClick={modalToggle}>
        //       <Col md="12" sm="12" lg="12" className={`float-left px-0 ${Styles.video_card_transform}`} style={{minHeight: '185px', maxHeight: '185px'}}>
        //         <div className={`${Styles.video_card_overlay}`} />
        //         <Col md="12" sm="12" lg="12" className={`float-left px-0`} id={`vimeo-`+props.video_id} style={{boxShadow: 'rgb(216, 214, 214) 0px 0px 9px 2px', borderRadius: '15px'}}>
        //           <picture>
        //             <LazyLoadImage src={background_url} alt={props.title === undefined ? 'video_background_image' : props.title} style={{width: "100%", minHeight: '185px', maxHeight: '185px', borderRadius: '15px'}}/>
        //           </picture>
        //         </Col>
        //         <Col sm="12" md="12" lg="12" className={`float-left ${props.title === undefined ? 'hidden' : ''}`} style={{zIndex: 2, position: 'absolute', bottom: '0', left: '0'}}>
        //           <h6 className="text-white ellipsis_2_effect" style={{textAlign: 'left', fontSize: '15px'}}> {props.title} </h6>
        //           <h6 className={`text-white ${props.practitioner_name === undefined || props.practitioner_name === '' ? 'd-none' : ''}`} style={{textAlign: 'left', fontSize: '12px'}}> {`By ${props.practitioner_name}`} </h6>
        //         </Col>
        //       </Col>
        //       <ModalVideo channel={props.channel} isOpen={modal_open} videoId={props.video_id} onClose={() => setModalToggle(false)} />
        //     </div>
        //   )
        // } else {
          return (
            <div className={`float-left mb-4 px-2`} style={{position: 'relative', maxWidth: '315px', minWidth: '315px'}} onClick={modalToggle}>
              <Col md="12" sm="12" lg="12" className={`float-left px-0 ${Styles.video_card_transform}`} style={{minHeight: '185px', maxHeight: '185px'}}>
                <div className={`${Styles.video_card_overlay}`} />
                <Col md="12" sm="12" lg="12" className={`float-left px-0`} id={props.channel === 'vimeo' ? `vimeo-${props.video_id}` : `youtube-${props.video_id}`} style={{boxShadow: 'rgb(216, 214, 214) 0px 0px 9px 2px', borderRadius: '15px'}}>
                  <picture>
                    <LazyLoadImage src={`https://img.youtube.com/vi/${props.video_id}/mqdefault.jpg`} alt={props.title === undefined ? 'video_background_image' : props.title} style={{width: "100%", minHeight: '185px', maxHeight: '185px', borderRadius: '15px'}}/>
                  </picture>
                </Col>
                <Col sm="12" md="12" lg="12" className={`float-left ${props.title === undefined ? 'hidden' : ''}`} style={{zIndex: 2, position: 'absolute', bottom: '0', left: '0'}}>
                  <h6 className="text-white ellipsis_2_effect" style={{textAlign: 'left', fontSize: '15px'}}> {props.title} </h6>
                  <h6 className={`text-white ${props.practitioner_name === undefined || props.practitioner_name === '' ? 'd-none' : ''}`} style={{textAlign: 'left', fontSize: '12px'}}> {`By ${props.practitioner_name}`} </h6>
                </Col>
              </Col>
              {displayPlayerModal()}
              {/* <ModalVideo channel={props.channel} isOpen={modal_open} videoId={props.video_id} onClose={() => setModalToggle(false)} /> */}
            </div>
          )
        // }
      }else if (props.video_page === 'sales_page_carousel_videos') {
        return (
          <div className={`float-left px-2`} style={{position: 'relative', maxWidth: '270px', minWidth: '270px'}} onClick={modalToggle}>
            <Col md="12" sm="12" lg="12" className={`float-left px-0`} style={{minHeight: '140px', maxHeight: '140px'}}>
              <div className={`${Styles.video_card_overlay}`} />
              <Col md="12" sm="12" lg="12" className={`float-left px-0`} id={props.channel === 'vimeo' ? `vimeo-${props.video_id}` : `youtube-${props.video_id}`} style={{borderRadius: '15px'}}>
                <picture>
                  <LazyLoadImage src={props.channel === 'vimeo' ? background_url : `https://img.youtube.com/vi/${props.video_id}/mqdefault.jpg`} alt={`${props.title.toLowerCase().split(' ').join('-')}`} style={{width: "100%", minHeight: '140px', maxHeight: '140px', borderRadius: '15px'}}/>
                </picture>
              </Col>
              <Col sm="12" md="12" lg="12" className={`float-left ${props.title === undefined ? 'hidden' : ''}`} style={{zIndex: 2, position: 'absolute', bottom: '0', left: '0'}}>
                <h6 className="text-white ellipsis_2_effect" style={{textAlign: 'left', fontSize: '14px'}}> {props.title} </h6>
              </Col>
            </Col>
            {displayPlayerModal()}
            {/* <ModalVideo channel={props.channel} isOpen={modal_open} videoId={props.video_id} onClose={() => setModalToggle(false)} /> */}
          </div>
        )
      }else if (props.video_page === 'sales_page_videos') {
        return (
          <Col sm="4" md="4" lg="4" className={`float-left mb-4 ${props.hidden}`} style={{position: 'relative'}} onClick={modalToggle}>
            <Col md="12" sm="12" lg="12" className={`float-left px-0 ${Styles.video_card_transform}`} style={{minHeight: '200px', maxHeight: '200px'}}>
              <div className={`${Styles.video_card_overlay}`} />
              <Col md="12" sm="12" lg="12" className={`float-left px-0`} id={props.channel === 'vimeo' ? `vimeo-${props.video_id}` : `youtube-${props.video_id}`} style={{boxShadow: 'rgb(216, 214, 214) 0px 0px 9px 2px', borderRadius: '15px'}}>
                <picture>
                  <LazyLoadImage src={props.channel === 'vimeo' ? background_url : `https://img.youtube.com/vi/${props.video_id}/mqdefault.jpg`} alt={`${props.title.toLowerCase().split(' ').join('-')}`} style={{width: "100%", minHeight: '200px', maxHeight: '200px', borderRadius: '15px'}}/>
                </picture>
              </Col>
              <Col sm="12" md="12" lg="12" className={`float-left ${props.title === undefined ? 'hidden' : ''}`} style={{zIndex: 2, position: 'absolute', bottom: '0', left: '0'}}>
                <h6 className="text-white ellipsis_2_effect" style={{textAlign: 'left', fontSize: '16px'}}> {props.title} </h6>
              </Col>
            </Col>
            {displayPlayerModal()}
            {/* <ModalVideo channel={props.channel} isOpen={modal_open} videoId={props.video_id} onClose={() => setModalToggle(false)} /> */}
          </Col>
        )
      }else if (props.video_page === 'resource_page_videos') {
        return (
          <Col xs="12" sm="12" md="12" lg="12" className="my-4 video-section float-left">
            <Col xs="3" sm="3" md="3" lg="3" className="text-center float-left">
              <Col xs="12" sm="12" md="12" lg="12" id={props.channel === 'vimeo' ? `vimeo-${props.video_id}` : `youtube-${props.video_id}`} >
                <picture>
                  <LazyLoadImage src={props.channel === 'vimeo' ? background_url : `https://img.youtube.com/vi/${props.video_id}/mqdefault.jpg`} alt={`${props.video.title.toLowerCase().split(' ').join('-')}`}/>
                </picture>
              </Col>
            </Col>
            <Col xs="9" sm="9" md="9" lg="9" className="float-left">
              <h3>{props.video.title}</h3>
              <p dangerouslySetInnerHTML={{ __html: props.video.description}}>
              </p>
            </Col>
          </Col>
        )
      }else if (props.video_page === 'speak_series_page') {
        return (
          <Col sm="9" md="9" lg="9" className="ml-5 mt-4 mb-2 float-left px-0 pointer" style={{ boxShadow: `0px 0px 4px 0px grey`,height: `100px`,borderRadius: `25px`}} onClick={modalToggle}>
            <Col sm="12" md="12" lg="12" className="video-section mt-1 float-left px-0 d-flex" style={{height: '100px'}}>
              <Col sm="2" md="2" lg="2" className="text-center float-left">
                <Col md="12" sm="12" lg="12" className={`float-left px-0`} id={props.channel === 'vimeo' ? `vimeo-${props.video_id}` : `youtube-${props.video_id}`}>
                  <picture>
                    <LazyLoadImage src={backgroundUrl()} alt={`${props.title.toLowerCase().split(' ').join('-')}`} style={{height: `80px`,borderRadius: `15px`,fontSize: '10px'}}/>
                  </picture>
                </Col>
              </Col>
              <Col sm="9" md="9" lg="9" className="float-left my-auto">
                <h6 className="">{props.title}</h6>
                <p dangerouslySetInnerHTML={{ __html: props.description}}></p>
              </Col>
              <Col sm="1" md="1" lg="1" className="float-left text-right">
                <FontAwesomeIcon className="mt-4" style={{margin: '0px 0px 0px -7px'}} icon={faAngleRight} size="1x" />
              </Col>
            </Col>
            {displayPlayerModal()}
            {/* <ModalVideo channel={props.channel} isOpen={modal_open} videoId={props.video_id} autoPlay={1} onClose={() => setModalToggle(false)} /> */}
          </Col>
        )
      }else {
        // if (props.channel === 'vimeo') {
        //   return (
        //     <Col sm="4" md="4" lg="4" className={`float-left mb-4 ${props.hidden}`} style={{position: 'relative'}} onClick={modalToggle}>
        //       <Col md="12" sm="12" lg="12" className={`float-left px-0 ${Styles.video_card_transform}`} style={{minHeight: '200px', maxHeight: '200px'}}>
        //         <div className={`${Styles.video_card_overlay}`} />
        //         <Col md="12" sm="12" lg="12" className={`float-left px-0`} id={`vimeo-`+props.video_id} style={{boxShadow: 'rgb(216, 214, 214) 0px 0px 9px 2px', borderRadius: '15px'}}>
        //           <picture>
        //             <LazyLoadImage src={background_url} alt={`${props.title.toLowerCase().split(' ').join('-')}`} style={{width: "100%", minHeight: '200px', maxHeight: '200px', borderRadius: '15px'}}/>
        //           </picture>
        //         </Col>
        //         {props.seo_slug  ?
        //           <ShareButton page_type="video" title={props.title} url={`${process.env.GATSBY_REACT_APP_API_WEBSITE}/videos/${props.seo_slug}`} summary={props.summary} style={{position: 'absolute', right: '0', color: 'rgb(255, 255, 255)', zIndex: 5, top: '2px'}}/>
        //           :
        //           <React.Fragment></React.Fragment>
        //         }
        //         <Col sm="12" md="12" lg="12" className={`float-left ${props.title === undefined ? 'hidden' : ''}`} style={{zIndex: 2, position: 'absolute', bottom: '0', left: '0'}}>
        //           <h6 className="text-white ellipsis_2_effect" style={{textAlign: 'left', fontSize: '1.2vw'}}> {props.title} </h6>
        //           <h6 className={`text-white ${props.practitioner_name === undefined || props.practitioner_name === '' ? 'd-none' : ''}`} style={{textAlign: 'left', fontSize: '0.95vw'}}> {`By ${props.practitioner_name}`} </h6>
        //         </Col>
        //       </Col>
        //       {displayPlayerModal()}
        //       {/* <ModalVideo channel={props.channel} isOpen={modal_open} videoId={props.video_id} onClose={() => setModalToggle(false)} /> */}
        //     </Col>
        //   )
        // } else {
          return (
            <Col sm="4" md="4" lg="4" className={`float-left mb-4 ${props.hidden}`} style={{position: 'relative'}} onClick={modalToggle}>
              <Col md="12" sm="12" lg="12" className={`float-left px-0 ${Styles.video_card_transform}`} style={{minHeight: '200px', maxHeight: '200px'}}>
                <div className={`${Styles.video_card_overlay}`} />
                <Col md="12" sm="12" lg="12" className={`float-left px-0`} id={props.channel === 'vimeo' ? `vimeo-${props.video_id}` : `youtube-${props.video_id}`} style={{boxShadow: 'rgb(216, 214, 214) 0px 0px 9px 2px', borderRadius: '15px'}}>
                  <picture>
                    <LazyLoadImage src={props.channel === 'vimeo' ? background_url : `https://img.youtube.com/vi/${props.video_id}/mqdefault.jpg`} alt={`${props.title.toLowerCase().split(' ').join('-')}`} style={{width: "100%", minHeight: '200px', maxHeight: '200px', borderRadius: '15px'}}/>
                  </picture>
                </Col>
                {props.seo_slug  ?
                  <ShareButton page_type="video" title={props.title} url={`${process.env.GATSBY_REACT_APP_API_WEBSITE}/videos/${props.seo_slug}`} summary={props.summary} style={{position: 'absolute', right: '0', color: 'rgb(255, 255, 255)', zIndex: 5, top: '2px'}}/>
                  :
                  <React.Fragment></React.Fragment>
                }
                <Col sm="12" md="12" lg="12" className={`float-left ${props.title === undefined ? 'hidden' : ''}`} style={{zIndex: 2, position: 'absolute', bottom: '0', left: '0'}}>
                  <h6 className="text-white ellipsis_2_effect" style={{textAlign: 'left', fontSize: '1.2vw'}}> {props.title} </h6>
                  <h6 className={`text-white ${props.practitioner_name === undefined || props.practitioner_name === '' ? 'd-none' : ''}`} style={{textAlign: 'left', fontSize: '0.95vw'}}> {`By ${props.practitioner_name}`} </h6>
                </Col>
              </Col>
              {displayPlayerModal()}
              {/* <ModalVideo channel={props.channel} isOpen={modal_open} videoId={props.video_id} onClose={() => setModalToggle(false)} /> */}
            </Col>
          )
        // }
      }
    }
  } else {
    return ''
  }
}
